import React, { useEffect, useState } from 'react';
import TabbedNavigation from '../components/Solution'
import SolutionBanner from '../components/SolutionBanner'
import ConsultingProcess from '../components/SolutionConsulation'
import ProductShowcase from '../components/SolutionProduct'

const SolutionPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    // Update isMobile state on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const styles = {
    hero: {
      marginTop: isMobile ? '30px' : '40px',
      marginBottom: isMobile ? '20px' : '20px',
    },
    hero2: {
      marginTop: isMobile ? '-20px' : '-20px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
    hero3: {
      marginTop: isMobile ? '25px' : '20px',
      // marginBottom: isMobile ? '20px' : '20px',
    },
  };
  return (
    <>
      <SolutionBanner />

      <div style={styles.hero3}>
        <TabbedNavigation />
</div>
        <div style={styles.hero2}>
        <ProductShowcase />
     </div>
        <div style={styles.hero}>
   
        <ConsultingProcess />
    
</div>
  
    </>
  )
}

export default SolutionPage
